import request from '../../../../shared/request'
import queryString from 'qs'

export function getOrganizationList(filters) {
  const qs = queryString.stringify(filters)
  return request(`/reports/financial/maintenance-financials-report/organization-list?${qs}`)
}

export function getFullReport(filters) {
  const qs = queryString.stringify(filters)
  return request(`/reports/financial/maintenance-financials-report/full-report?${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/financial/maintenanceFinancialsReport.js